import { render, staticRenderFns } from "./searchComs.vue?vue&type=template&id=19101503&"
import script from "./searchComs.vue?vue&type=script&lang=js&"
export * from "./searchComs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports